import { B2BPaymentTypeEnum } from '@spartacus/checkout/b2b/root'

declare module '@spartacus/checkout/b2b/root' {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  enum B2BPaymentTypeEnum {
    INVOICE = 'INVOICE'
  }
}
// eslint-disable-next-line @typescript-eslint/dot-notation
(B2BPaymentTypeEnum as any)['INVOICE'] = 'INVOICE'
